import createParseMiddleware from './createParseMiddleware';
import { parseVisitResponse, parseNoteResponse, parseVisitorAgreementResponse } from 'utils/apiParser/visitParser';
import { Visit, Note, VisitorAgreement } from 'types/visitTypes';

export const parseFetchVisitsMiddleware = createParseMiddleware<Visit>(parseVisitResponse, 'visitors/fetchVisits');
export const parseDescribeVisitMiddleware = createParseMiddleware<Visit>(parseVisitResponse, 'visitors/describeVisit');
export const parseFetchVisitNotesMiddleware = createParseMiddleware<Note>(parseNoteResponse, 'visitors/fetchVisitNotes');
export const parseFetchVisitorAgreementsMiddleware = createParseMiddleware<VisitorAgreement>(parseVisitorAgreementResponse, 'visitors/fetchVisitorAgreements');

